/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookienoticedescription2Inputs */



/**
* | output |
* | --- |
* | "Delegator uses technically necessary cookies to enable the use of the app." |
*
* @param {Cookienoticedescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cookienoticedescription2 = /** @type {((inputs?: Cookienoticedescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookienoticedescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Delegator uses technically necessary cookies to enable the use of the app.")
	return /** @type {LocalizedString} */ ("Wir verwenden technisch notwendige Cookies, um das Benutzen der App zu ermöglichen.")
});
export { cookienoticedescription2 as "cookieNoticeDescription" }